import type {
  HubBinaryFileBrandingField,
  HubColorBrandingField,
  HubTextFileBrandingField,
  HubUrlBrandingField,
} from '@robovision/hub'
import { HubBrandingItemId } from '@robovision/hub'


type HubFileBrandingField = HubBinaryFileBrandingField | HubTextFileBrandingField
type HubBrandingField = HubColorBrandingField | HubFileBrandingField | HubUrlBrandingField

export interface BrandingParams {
  fileTypes?: string[]
  id: HubBrandingItemId
  maxSize?: number
  type?: string
}

export class Branding {
  public readonly fileTypes?: string[]
  public readonly id: HubBrandingItemId
  public readonly maxSize?: number
  public readonly type?: string

  public constructor (params: BrandingParams) {
    this.fileTypes = params.fileTypes
    this.id = params.id
    this.maxSize = params.maxSize
    this.type = params.type

    Object.freeze(this)
  }

  public get labelI18nPath (): {
    description?: string
    hint?: string
    label: string
  } | undefined {
    switch (this.id) {
      // TODO: add more cases when we have them.
      case HubBrandingItemId.PrimaryColor:
        return {
          description: 'about.branding.colorTooltip',
          label: 'about.branding.color',
        }
      case HubBrandingItemId.CookiePolicy:
        return {
          description: 'about.branding.cookiePolicyTooltip',
          label: 'about.branding.cookiePolicy',
        }
      case HubBrandingItemId.DocumentationUrl:
        return {
          hint: 'about.branding.userDocumentationHint',
          label: 'about.branding.userDocumentation',
        }
      case HubBrandingItemId.Favicon:
        return {
          description: 'about.branding.faviconDescription',
          label: 'about.branding.favicon',
        }
      case HubBrandingItemId.Logo:
        return {
          label: 'about.branding.logoLabel',
        }
      case HubBrandingItemId.OnScreenText:
        return {
          description: 'about.branding.translationsTooltip',
          label: 'about.branding.onScreenText',
        }
      case HubBrandingItemId.PrivacyPolicy:
        return {
          description: 'about.branding.privacyPolicyTooltip',
          label: 'about.branding.privacyPolicy',
        }
      case HubBrandingItemId.TermsAndConditions:
        return {
          description: 'about.branding.termsAndConditionsTooltip',
          label: 'about.branding.termsAndConditions',
        }
      default:
        return undefined
    }
  }

  public static fromResponse (data: HubBrandingField) {
    if (data.type === 'file') {
      const fileData = data as HubFileBrandingField
      return new Branding({
        fileTypes: fileData.fileExtensions,
        id: fileData.id,
        maxSize: fileData.maxSize,
        type: fileData.type,
      })
    } else {
      return new Branding({
        fileTypes: [],
        id: data.id,
        maxSize: -1,
        type: data.type,
      })
    }
  }
}
